import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import { SlArrowRight } from "react-icons/sl";
import { useUser } from "../../../context/user-context";
import { IoMailOutline } from "react-icons/io5";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { CgCloseR } from "react-icons/cg";
import { Link } from "react-router-dom";
import { PiWhatsappLogo } from "react-icons/pi";

const LinkedAccount = ({
  setOpenLinkedAccount,
  setOpenAddPhone,
  setOpenSecurity,
}: any) => {
  const { userDetails } = useUser();
  const email = userDetails?.user?.email?.address;
  const emailVerified = userDetails?.user?.email?.isVerified;
  const whatsappVerified = userDetails?.user?.phone?.isVerified;
  const whatsapp = userDetails?.user?.phone?.number;
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenLinkedAccount(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Linked Accounts
          </h4>
        </div>
        <div className="w-full mt-6">
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <IoMailOutline className="text-[#0B75C2] text-[28px]" />
              <div>
                <h4 className="text-gray-900 dark:text-gray-100 font-semibold text-[16px] ">
                  Email
                </h4>
                <h4 className="text-gray-500  text-[13px]  ">{email}</h4>
              </div>
            </div>
            <div className="flex        gap-2  items-center">
              {emailVerified ? (
                <div className="flex items-center gap-1 text-[#0D851D]">
                  <IoMdCheckmarkCircleOutline className="text-[20px]" />
                  <h4 className="text-[14px] font-medium ">Linked</h4>
                </div>
              ) : (
                <Link
                  to="/signup"
                  className="flex items-center gap-1 text-[#BF8221]"
                >
                  <CgCloseR className="text-[20px]" />
                  <h4 className="text-[14px] font-medium ">Unverified</h4>
                </Link>
              )}

              <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
            </div>
          </div>
          <div className="flex justify-between py-5 border-b border-gray-200 dark:border-gray-700  items-center cursor-pointer">
            <div className="flex justify-start items-center gap-4">
              <PiWhatsappLogo className="text-[#0B75C2] text-[28px]" />
              <div>
                <h4 className="text-gray-900 dark:text-gray-100 font-semibold text-[16px] ">
                  WhatsApp{" "}
                </h4>
                <h4 className="text-gray-500  tracking-wide  text-[13px]  ">
                  {whatsapp ? whatsapp : "Not Linked"}
                </h4>
              </div>
            </div>
            <div className="flex        gap-2  items-center">
              {whatsappVerified ? (
                <div className="flex items-center gap-1 text-[#0D851D]">
                  <IoMdCheckmarkCircleOutline className="text-[20px]" />
                  <h4 className="text-[14px] font-medium ">Linked</h4>
                </div>
              ) : (
                <button
                  onClick={() => {
                    setOpenSecurity(false);
                    setOpenLinkedAccount(false);
                    setOpenAddPhone(true);
                  }}
                  className="flex items-center gap-1 text-[#BF8221]"
                >
                  <CgCloseR className="text-[20px]" />
                  <h4 className="text-[14px] font-medium ">Unverified</h4>
                </button>
              )}

              <SlArrowRight className="text-gray-500 dark:text-gray-200 text-[16px]" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinkedAccount;
